import React from 'react'
import { Bar, Radar } from "react-chartjs-2";

import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';

const RadarChart = (props) => {
    return (
        <>
            {props?.data &&
                <Radar data={props?.data} options={props?.options}></Radar>
            }
        </>
    )
};

export default RadarChart